<template>
    <section class="banner-section">
        <img class="img1 wow fadeInLeft" src="/assets/images/banner/aimg1.png" alt="">
        <img class="img2 wow fadeInRight" src="/assets/images/banner/aimg2.png" alt="">
    </section>
</template>